import React from 'react'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'
import IntroSection from '../../components/IntroSection'
import { introdata } from '../../content_option'

export const Home = () => {
  return (
    <PageLayout id="home" className="home">
      <IntroSection
        title={introdata.title}
        titleLink="#"
        backgroundImage={introdata.img_url}
        typewriterStrings={[introdata.description]}
      >
        <ul className='list mb-1x'>
          <li>
            <Link className='d-flex justify-content-start' to='/blog'>
              {introdata.links.blog}
              <div className='arrow'>→</div>
            </Link>
          </li>
          <li>
            <Link className='d-flex justify-content-start' to='/travel'>
              {introdata.links.travel}
              <div className='arrow'>→</div>
            </Link>
          </li>
          <li>
            <Link
              className='d-flex justify-content-start'
              to='/projects'
            >
              {introdata.links.projects}
              <div className='arrow'>→</div>
            </Link>
          </li>
        </ul>
      </IntroSection>
    </PageLayout>
  )
}
